export function calcColumns(totalOptions: number): number {
  if (totalOptions <= 2) return 12;
  if (totalOptions <= 12) return 6;
  if (totalOptions <= 24) return 4;
  return 3;
}
